import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { CheckboxRadioAlign } from '../../enums';
import { Checkbox } from '../Checkbox';
import styles from './CheckboxGroup.module.scss';
const CheckboxGroup = ({ className = '', onSelect, options, textAlign = CheckboxRadioAlign.Center, }) => (_jsx(_Fragment, { children: options.map(option => (_jsx(Checkbox, { id: option.label, onChange: event => onSelect(option.value, event), checked: option.isSelected, classNames: {
            wrapperClassName: classNames(styles.option, {
                [styles.selected]: option.isSelected,
            }, className),
        }, textAlign: textAlign, children: _jsxs("div", { className: "d-flex flex-grow-1 justify-content-between", children: [_jsx("div", { children: option.label }), !!option.secondaryText && (_jsx("div", { className: styles.secondaryText, children: option.secondaryText }))] }) }, option.label))) }));
export { CheckboxGroup };
